import { Button } from "@chakra-ui/react";
import React from "react";
import { FiCalendar } from "react-icons/fi";

const fmt = (iso: string) => new Date(iso).toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");

/** „Dodaj do kalendarza" — generuje i pobiera plik .ics ze startem głosowania. */
export const AddToCalendarButton: React.FC<{ title: string; start: string; end: string; url: string }> = ({ title, start, end, url }) => {
  const download = () => {
    if (!start) return;
    const ics = [
      "BEGIN:VCALENDAR",
      "VERSION:2.0",
      "PRODID:-//lubbezposrednio//decyduj//PL",
      "CALSCALE:GREGORIAN",
      "BEGIN:VEVENT",
      `UID:${fmt(start)}-${Math.floor(Math.random() * 1e6)}@lubbezposrednio.pl`,
      `DTSTAMP:${fmt(new Date().toISOString())}`,
      `DTSTART:${fmt(start)}`,
      `DTEND:${fmt(end || start)}`,
      `SUMMARY:Głosowanie: ${title}`,
      `DESCRIPTION:Oddaj głos: ${url}`,
      `URL:${url}`,
      "BEGIN:VALARM",
      "TRIGGER:-PT1H",
      "ACTION:DISPLAY",
      "DESCRIPTION:Głosowanie zaczyna się za godzinę",
      "END:VALARM",
      "END:VEVENT",
      "END:VCALENDAR"
    ].join("\r\n");

    const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
    const href = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = href;
    a.download = "glosowanie.ics";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(href);
  };

  return (
    <Button onClick={download} leftIcon={<FiCalendar />} variant="outline" borderColor="primary" color="primary" borderRadius="12px" fontWeight="700" size="sm" h="40px" px="16px" _hover={{ bg: "rgba(67,0,152,0.05)" }}>
      Dodaj do kalendarza
    </Button>
  );
};
